import { render, staticRenderFns } from "./GenesisG80Disclosure2024.vue?vue&type=template&id=126e1871&"
import script from "./GenesisG80Disclosure2024.vue?vue&type=script&lang=js&"
export * from "./GenesisG80Disclosure2024.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports